import { parseNumberVariable } from '@/helpers/envs';
import { Apps } from '@/constants/apps';

const {
  VUE_APP_XSOLLA_HOMESCAPES_PROJECT_ID: homescapesProjectId,
  VUE_APP_XSOLLA_TOWNSHIP_PROJECT_ID: townshipProjectId,
  VUE_APP_XSOLLA_HOMESCAPES_CLIENT_ID: homescapesClientId,
  VUE_APP_XSOLLA_TOWNSHIP_CLIENT_ID: townshipClientId,
  VUE_APP_XSOLLA_CALLBACK_URL: CALLBACK_URL,
  VUE_APP_XSOLLA_REDIRECT_URI: REDIRECT_URI,
  VUE_APP_XSOLLA_PROVIDER_LINK_URI: PROVIDER_LINK_URI,
  VUE_APP_XSOLLA_API_URL: API_URL,
  VUE_APP_XSOLLA_SETTINGS_JSON_URL: SETTINGS_JSON_URL,
  VUE_APP_XSOLLA_SOCIALS_JSON_URL: SOCIALS_JSON_URL,
  VUE_APP_XSOLLA_TOWNSHIP_CUSTOM_LABELS_URL: TOWNSHIP_CUSTOM_LABELS_URL,
} = process.env;

const PROJECT_IDS: Record<Apps, string> = {
  [Apps.Homescapes]: homescapesProjectId || '',
  [Apps.Township]: townshipProjectId || '',
};

const CLIENT_IDS: Record<Apps, number> = {
  [Apps.Homescapes]: parseNumberVariable(homescapesClientId),
  [Apps.Township]: parseNumberVariable(townshipClientId),
};

export {
  PROJECT_IDS,
  CLIENT_IDS,
  CALLBACK_URL,
  REDIRECT_URI,
  PROVIDER_LINK_URI,
  API_URL,
  SETTINGS_JSON_URL,
  SOCIALS_JSON_URL,
  TOWNSHIP_CUSTOM_LABELS_URL,
};
